import { Warning } from "@mui/icons-material";
import { Tooltip } from "@mui/material";
import { differenceInCalendarDays } from "date-fns";
import { Driver } from "../../../graphql/generated";

type DriverMedicalExpiryWarningProps = {
  driver: {
    medical?:
      | Pick<Exclude<Driver["medical"], undefined | null>, "expiryDate">
      | undefined
      | null;
  };
};

const DriverMedicalExpiryWarning = ({
  driver,
}: DriverMedicalExpiryWarningProps) => {
  const medicalExpiryRemainingDays = driver.medical?.expiryDate
    ? differenceInCalendarDays(new Date(driver.medical.expiryDate), new Date())
    : Infinity;
  return medicalExpiryRemainingDays <= 0 ? (
    <Tooltip title="Driver medical expired">
      <Warning color="error" />
    </Tooltip>
  ) : medicalExpiryRemainingDays <= 14 ? (
    <Tooltip
      title={`Driver medical expires in ${medicalExpiryRemainingDays} day${
        medicalExpiryRemainingDays > 1 ? "s" : ""
      }`}
    >
      <Warning color="warning" />
    </Tooltip>
  ) : null;
};

export default DriverMedicalExpiryWarning;